export const PDFFILE = {
	'files/Premium-Compulsory-File.pdf': require('./files/Premium-Compulsory-File.pdf')
}
